import * as React from "react"
import { Modal } from "react-bootstrap"
import { LocationInformationForm } from "./LocationInformationForm"

interface AddLocationModalProps {
  show: boolean
  portalID: number
  companyID: number
  onHide: () => void
  onSuccess: () => void
}

export class AddLocationModal extends React.PureComponent<AddLocationModalProps> {
  render() {
    const { show, onHide, onSuccess, companyID, portalID } = this.props

    return <Modal backdrop="static" centered show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Create New Location</Modal.Title>
      </Modal.Header>
      <LocationInformationForm portalID={portalID} companyID={companyID} onCancel={onHide} add={true} onSuccess={onSuccess} />
    </Modal>
  }
}
